const FilesUtils = {
  ensureSlashInPath(path) {
    if (!(/^\//).test(path)) {
      return '/' + path
    }

    return path
  }
}

export default FilesUtils


// WEBPACK FOOTER //
// ./src/files/utils.js